import {handleData} from "../utils/handleData";

export function getItemForPost(entry, timelineElement) {
    var tmpShopCode = entry.shop_code;
    if (tmpShopCode === "" || tmpShopCode === null) {
        tmpShopCode = shopCode;
    }
    var tmpLanguageCode = entry.language_code;
    if (tmpLanguageCode === "" || tmpLanguageCode === null) {
        tmpLanguageCode = languageCode;
    }
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_item_for_post",
        datatype: "json",
        data: {
            "ajax_call_id": entry.id,
            "ajax_call_item_no": entry.item_no,
            "ajax_call_type": entry.type,
            "ajax_call_company": company,
            "ajax_call_shop_code": tmpShopCode,
            "ajax_call_language_code": tmpLanguageCode
        },
        success: function (output) {
            handleData(output, timelineElement);
        }
    });
}
